// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"44fcaa25","942":"50bf1e7f"}[chunkId] + ".chunk.css";
};